import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../../../assets/fonts/kids_avenue/KidsAvenue";

const NewPanApplicationAdminReport = () => {
  const [panData, setPanData] = useState([]);
  const tableRef = useRef(null);

  useEffect(() => {
    const fetchPanData = async () => {
      try {
        // Retrieve token from localStorage or sessionStorage
        const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

        const response = await fetch(`${API_BASE_URL}/NewPanApplication/GetNewPanRecords`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`, // Attach token in the request                       
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        let data = await response.json();

        // Add SrNo property to each record
        data = data.map((record, index) => ({
          ...record,
          SrNo: index + 1 // Auto-incrementing SrNo
        }));

        setPanData(data); // Update state with modified data
      } catch (error) {
        console.error('Failed to fetch pan records:', error);
      }
    };

    fetchPanData();
  }, []);

  console.log(panData);

  // Function to update status
  const handleStatusChange = async (registrationNo, newStatus) => {
    const comment = prompt("Enter comment for this status change:");
    if (!comment) return; // Optional: require comment

    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/NewPanApplication/updateStatus/${registrationNo}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ status: newStatus, comment }),
      });

      if (!response.ok) throw new Error("Failed to update status");

      // Update state only after successful API call
      setPanData(prev =>
        prev.map(row =>
          row.registrationNo === registrationNo
            ? { ...row, status: newStatus, comment }
            : row
        )
      );

    } catch (error) {
      console.error("Error updating status:", error);
    }
  };


  const generatePDF = (record) => {
    const doc = new jsPDF("p", "pt", "a4");

    // Register font from VFS
    doc.setFont("KidsAvenue", "normal");

    const content = `
    <div class="paper">
      <h3 class="text-center">SUBMITTED FORM PAN</h3>
      <div class="meta">
        <div class="left">Registration No: <strong>${record.registrationNo || "-"}</strong></div>
        <div class="right">Date: <strong>${record.submissionDate
        ? new Date(record.submissionDate).toLocaleDateString("en-GB")
        : "-"}</strong></div>
      </div>

      <h4>AO Code</h4>
      <div class="form-row">
        <div class="ao-container">
          <div class="labeldiv"><P>Area Code</P></div>
          <div class="ao-box">${record.areaCode || "-"}</div>

          <div class="labeldiv"><P>AO Type</P></div>
          <div class="ao-box">${record.aoType || "-"}</div>

          <div class="labeldiv"><P>Range Code</P></div>
          <div class="ao-box">${record.rangeCode || "-"}</div>

          <div class="labeldiv"><P>AO Code</P></div>
          <div class="ao-box">${record.aoCode || "-"}</div>
        </div>
      </div>
      
      <div class="form-row"><label>Status Of Applicant</label><input class="input-box small" value="${record.applicantType || "-"}"/></div>
   
      <div class="form-row"><label>Label</label><input class="input-box small" value="${record.applicantCheckedOption || "-"}"/></div>

      <div style="margin-top:8px; font-size:13px; font-weight:700;">Applicant Name</div>
      <table style="width:100%; border-collapse:collapse; font-size:12px;" id="nameTable">
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:6px;">First Name</th>
            <th style="border:1px solid #000; padding:6px;">Middle Name</th>
            <th style="border:1px solid #000; padding:6px;">Last Name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="border:1px solid #000; padding:6px;">${record.firstName || "-"}</td>
            <td style="border:1px solid #000; padding:6px;">${record.middleName || "-"}</td>
            <td style="border:1px solid #000; padding:6px;">${record.lastName || "-"}</td>
          </tr>
        </tbody>
      </table>

      <div class="form-row"><label>Name as you would like it, to be printed on the PAN card</label><input class="input-box small" value="${record.NewPanName || "-"}"/>
      </div>


      <div class="form-row"><label>Father name</label><input class="input-box small" value="${record.fatherFirstName || "-"}"/>
      <input class="input-box small" value="${record.fatherMiddleName || "-"}"/> <input class="input-box small" value="${record.fatherLastName || "-"}"/>
      </div>

      <div class="form-row"><label>Mother name</label><input class="input-box small" value="${record.motherFirstName || "-"}"/>
      <input class="input-box small" value="${record.motherMiddleName || "-"}"/> <input class="input-box small" value="${record.motherLastName || "-"}"/>
      </div>
      <div class="form-row"><label>Date of Birth / Incorporation</label>
      <input class="input-box small" value="${record.date ? new Date(record.date).toLocaleDateString("en-GB") : "-"}"/>
      </div>
      <div class="form-row"><label> Contact Details</label>
      <input class="input-box small" value="+91"/>
      <input class="input-box small" value="${record.stdCode || "-"}"/>
      <input class="input-box small" value="${record.mobileNo || "-"}"/>
      </div>
      <div class="form-row"><label>Email address</label>
      <input class="input-box small" value="${record.emailId || "-"}"/>
      </div>
       <div class="form-row"><label>Name as per Aadhar</label>
      <input class="input-box small" value="${record.aadharName || "-"}"/>
      </div>
       <div class="form-row"><label>Pan Card Dispatched State</label>
      <input class="input-box small" value="${record.panDispatchState || "-"}"/>
      </div>
      <div class="form-row"><label>Aadhaar/EID</label>
      <input class="input-box small" value="${record.aadhar_EID || "-"}"/>
      </div>
      <div class="form-row"><label>RA Address</label>
      <input class="input-box small" value="${record.raAddress || "-"}"/>
      </div>

      <h4>Resident Address</h4>

      <div class="form-row"><label>Flat/ Room/ Block No.</label><input class="input-box" value="${record.residentRoom || "-"}"/></div>
      <div class="form-row"><label>Name Premises/ Bldg/ Village</label><input class="input-box" value="${record.residentPremises || "-"}"/></div>
      <div class="form-row"><label>Road/ Street/ Lane/ Post</label><input class="input-box" value="${record.residentStreet || "-"}"/></div>
      <div class="form-row"><label>Area/ Locality/ Taluka</label><input class="input-box" value="${record.residentArea || "-"}"/></div>
      <div class="form-row">
      <label>Town/ City/ District</label><input class="input-box" value="${record.residentCity || "-"}"/>
      <label>State/ Union Territory</label><input class="input-box" value="${record.residentState || "-"}"/>
      <label>PIN Code</label><input class="input-box small" value="${record.residentPinCode || "-"}"/>
      </div>

      <h4>Office Address</h4>
      <div class="form-row"><label>Office Name</label><input class="input-box" value="${record.officeName || "-"}"/></div>
      <div class="form-row"><label>Flat/ Room/ Block No.</label><input class="input-box" value="${record.officeRoom || "-"}"/></div>
      <div class="form-row"><label>Name Premises/ Bldg/ Village</label><input class="input-box" value="${record.officePremises || "-"}"/></div>
      <div class="form-row"><label>Road/ Street/ Lane/ Post</label><input class="input-box" value="${record.officeStreet || "-"}"/></div>
      <div class="form-row"><label>Area/ Locality/ Taluka</label><input class="input-box" value="${record.officeArea || "-"}"/></div>
      
      <div class="form-row">
      <label>Town/ City/ District</label><input class="input-box" value="${record.officeCity || "-"}"/>
      <label>State/ Union Territory</label><input class="input-box" value="${record.officeState || "-"}"/>
      <label>PIN Code</label><input class="input-box small" value="${record.officePinCode || "-"}"/>
      </div>



      <h4>Representative Details</h4>
      <div class="form-row"><label>Full Name ( RA )</label><input class="input-box small" value="${record.representativeCheckedOption || "-"}"/>
      <input class="input-box small" value="${record.representativeCheckedOption || "-"}"/>
      <input class="input-box small" value="${record.representativeCheckedOption || "-"}"/></div>
      <div class="form-row"><label>Flat/ Room/ Block No.</label><input class="input-box" value="${record.representativeFirstName || "-"}"/></div>
      <div class="form-row"><label>Name of premises/ Bldg/ Village</label><input class="input-box" value="${record.representativeMiddleName || "-"}"/></div>
      <div class="form-row"><label>Road/ Street/ Lane/ Post</label><input class="input-box" value="${record.representativeLastName || "-"}"/></div>
      <div class="form-row"><label>Area/ Locality/ Taluka</label><input class="input-box" value="${record.representativeCity || "-"}"/></div>
      
      <div class="form-row">
      <label>Town/ City/ District</label><input class="input-box" value="${record.residentCity || "-"}"/>
      <label>State/ Union Territory</label><input class="input-box" value="${record.residentState || "-"}"/>
      <label>PIN Code</label><input class="input-box small" value="${record.residentPinCode || "-"}"/>
      </div>

      
      <div class="form-row"><strong>Retailer Name: ${record.retailerName || "-"}</strong></div>
    </div>
  `;

    doc.html(content, {
      callback: function (doc) {
        doc.save(`NewPanApplication_${record.registrationNo}.pdf`);
      },
      x: 10,
      y: 10,
      html2canvas: { scale: 0.55 },
    });
  };

  useEffect(() => {
    if (tableRef.current && panData.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true, // Destroy existing table instance
        data: panData,
        columns: [
          { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
          { data: 'startDate', title: 'Date' }, // Matches 'startDate'
          { data: 'name', title: 'Applicant Name' }, // Matches 'name'
          { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'                  
          {
            data: 'status',
            title: 'Status',
            render: function (data, type, row) {
              return `
                          <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                            <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                            <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                            <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                            <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                          </select>
                        `;
            }
          },
          { data: 'comment', title: 'Comment' },
          {
            data: null,
            title: "Submitted Form",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
            },
          },
          {
            data: null,
            title: "PDFDocument",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='PdfDocument'>Download</button>`;
            },
          },
          {
            data: null,
            title: "Photo",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='Photo'>Download</button>`;
            },
          },
          {
            data: null,
            title: "Signature",
            render: function (data, type, row) {
              return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}' data-type='Signature'>Download</button>`;
            },
          },
          {
            data: null,
            title: "Upload Receipt",
            render: (data, type, row) => {
              const fileName = row.panReceiptPath ? row.panReceiptPath.split('/').pop() : '';
              return `
                                <input type='file' class='file-input' data-id='${row.registrationNo}' style='display:none;' accept='.pdf,.jpg,.png,.docx'/>
                                <button class='btn btn-sm btn-warning upload-btn' data-id='${row.registrationNo}'>Upload</button>
                                <div class='file-name' data-id='${row.registrationNo}' style='margin-top: 5px; font-size: 12px; color: green;'>${fileName}</div>
                            `;
            }
          }
        ]
      });

      // Handle status change
      $(tableRef.current).on("change", ".status-dropdown", function () {
        const registrationNo = $(this).attr("data-id");
        const newStatus = $(this).val();
        const comment = ""; // Or however you get it
        handleStatusChange(registrationNo, newStatus, comment);
      });

      // Handle download button click
      $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
        const registrationNo = String($(this).data("id")); // force string           
        downloadPDF(registrationNo, "form");
      });

      // Handle all other document downloads
      $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
        const registrationNo = $(this).data("id");
        const fileType = $(this).data("type");
        downloadPDF(registrationNo, fileType);
      });

      // Handle Upload Button Click
      $("#productsTable tbody").off("click", ".upload-btn").on("click", ".upload-btn", function () {
        const registrationNo = $(this).data("id"); // Ensure this is a string
        $(`.file-input[data-id='${registrationNo}']`).trigger("click");
      });

      // Handle File Selection
      $("#productsTable tbody").off("change", ".file-input").on("change", ".file-input", function () {
        const registrationNo = $(this).data("id"); // Ensure this is a string
        const file = this.files[0];
        if (file) {
          uploadFile(registrationNo, file);
        }
      });

      return () => {
        table.destroy();
        $(tableRef.current).off("change", ".status-dropdown");
      };
    }
  }, [panData]);
  const downloadPDF = async (registrationNo, type) => {
    try {
      const authToken = localStorage.getItem("authToken");
      // const endpoint = type === "form"
      // ? `http://localhost:5121/api/NewPanApplication/DownloadPdf/${registrationNo}`
      // : `http://localhost:5121/api/NewPanApplication/DownloadDocument/${registrationNo}/${type}`;

      //  const endpoint = type === "form"
      //  ? `https://apiv2.chakran.in/api/NewPanApplication/DownloadPdf/${registrationNo}`
      //  : `https://apiv2.chakran.in/api/NewPanApplication/DownloadDocument/${registrationNo}/${type}`;

      const endpoint = type === "form"
        ? `${API_BASE_URL}/NewPanApplication/DownloadPdf/${registrationNo}`
        : `${API_BASE_URL}/NewPanApplication/DownloadDocument/${registrationNo}/${type}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        let errorMessage = `Failed to download file: ${response.status}`;
        try {
          const errorData = await response.json();
          if (errorData && errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          // Response was not JSON
        }
        alert(`❌ ${errorMessage}`);
        throw new Error(errorMessage);
      }

      if (type === "form") {
        // ✅ API returns JSON (data for form)
        const record = await response.json();
        console.log("📌 API Data:", record);

        // Use frontend design
        generatePDF(record);
      } else {

        // ✅ For documents, API returns blob
        const blob = await response.blob();
        const contentType = response.headers.get("Content-Type");

        // Determine file extension from MIME type
        const fileExtension = contentType.split("/")[1] || "pdf"; // Example: 'image/png' → 'png'

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `NewPanApplication_${type}_${registrationNo}.${fileExtension}`; // or .jpg depending on file
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download error:", error);
    }
    //     const blob = await response.blob();
    //     const contentType = response.headers.get("Content-Type");

    //     // Determine file extension from MIME type
    //     const fileExtension = contentType.split("/")[1] || "pdf"; // Example: 'image/png' → 'png'

    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = `NewPanApplication_${type}_${registrationNo}.${fileExtension}`;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    // } catch (error) {
    //     console.error("Download error:", error);
    // }
  };

  // File Upload Function
  const uploadFile = async (registrationNo, file) => {
    console.log("File selected:", file.name);  // Log the file name here
    try {
      const authToken = localStorage.getItem("authToken");
      const formData = new FormData();
      formData.append("file", file);

      // ✅ Use backticks (`) for the correct API URL format
      const response = await fetch(`${API_BASE_URL}/NewPanApplication/upload-receipt/${registrationNo}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${authToken}` }, // No 'Content-Type' for FormData
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to upload file: ${response.status}`);
      }

      const data = await response.json();
      alert("✅ File uploaded successfully!");

      // ✅ Show file name below button
      $(`.file-name[data-id='${registrationNo}']`).text(file.name);

      // Update the data state with the correct file path
      const updatedData = panData.map((item) =>
        item.registrationNo === registrationNo
          ? { ...item, panReceiptPath: data.FilePath }
          : item
      );

      setPanData(updatedData);

      // ✅ Now use the updated data to redraw the table
      const table = $('#productsTable').DataTable();
      table.clear();
      table.rows.add(updatedData); // ✅ Updated data
      table.draw();

    } catch (error) {
      console.error("Upload error:", error);
      alert("❌ Failed to upload file.");
    }
  };

  return (

    <table
      ref={tableRef}
      id="productsTable"
      className="table table-bordered table-hover table-product"
      style={{ width: '100%' }}
    >
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Date</th>
          <th>Applicant Name</th>
          <th>Registration No</th>
          <th>Status</th>
          <th>Comment</th>
          <th>Submitted Form</th>
          <th>PDFDocument</th>
          <th>Photo</th>
          <th>Signature</th>
          <th>Upload Receipt</th>

        </tr>
      </thead>
    </table>

  );
};
export default NewPanApplicationAdminReport;